import { assignInlineVars } from "@vanilla-extract/dynamic";
import type React from "react";
import type { CSSProperties } from "react";
import { forwardRef, useMemo } from "react";
import type { ColorType } from "../../utils/consts";
import { TakeatLogo } from "../TakeatLogo";
import {
  developedByTakeatContainerClass,
  flexDirectionVar,
  fontSizeVar,
  heightVar,
  spanClass,
  widthVar,
} from "./styles.css";

interface DevelopedByTakeatProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: ColorType;
  customColor?: string;
  spanStyles?: React.CSSProperties;
  horizontal?: boolean;
  width?: number;
  height?: number;
}

export const DevelopedByTakeat = forwardRef(function DevelopedByTakeat(
  {
    color,
    customColor,
    spanStyles,
    horizontal = false,
    width,
    height,
    ...props
  }: DevelopedByTakeatProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const dynamicStyles = useMemo(() => {
    const fontSize = width
      ? (width * 12) / 105
      : height
        ? (height * 12) / 25
        : 12;

    return assignInlineVars({
      [flexDirectionVar]: horizontal ? "row" : "column",
      [widthVar]: horizontal || !width ? "auto" : `${width}px`,
      [heightVar]: !horizontal || !height ? "auto" : `${height}px`,
      [fontSizeVar]: `${fontSize}px`,
    }) as unknown as CSSProperties;
  }, [horizontal, width, height]);

  return (
    <div
      ref={ref}
      className={developedByTakeatContainerClass}
      style={dynamicStyles}
      {...props}
    >
      <span className={spanClass} style={spanStyles}>
        Desenvolvido por
      </span>
      <TakeatLogo
        color={color}
        customColor={customColor}
        width={horizontal ? undefined : "80%"}
        height={horizontal ? "100%" : undefined}
      />
    </div>
  );
});

DevelopedByTakeat.displayName = "DevelopedByTakeat";
